module.exports = __webpack_public_path__ + "static/dl2-stay-human_tablet1-a56b6ff3f08ccee7083f1b6da00948ae.png";